<template>
  <section>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@40,400,0,0"
    />
    <VerReporte />
    <VerDocumento />
    <VerPermiso />
  
    <AprobarRRHHSinPermisos />
    <v-card class="p-0">
      <v-card-text class="p-0">
        <!-- Cabecera del formulario -->
        <v-card-title class="headline">
          <v-flex xs12>
            <span class="material-symbols-outlined"> leaderboard </span>
            Reporte de permisos 
          </v-flex>
          <v-spacer></v-spacer>
        </v-card-title>
        <!-- Cuerpo del formulario -->
        <v-form
          @submit.prevent="save"
          v-model="valid"
          ref="form"
          lazy-validation
        >
          <v-card-text>
            <v-container grid-list-md class="p-0" style="min-width: 100%">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    class="text-field-reducido"
                    type="date"
                    v-model="form.fecha_inicio"
                    label="Fecha inicio"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    :rules="$validate(['required'])"
                    required
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    class="text-field-reducido"
                    type="date"
                    v-model="form.fecha_fin"
                    label="Fecha fin"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    :rules="$validate(['required'])"
                    required
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex md12>
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="tipo_permisos"
                    item-value="descripcion"
                    item-text="descripcion"
                    v-model="form.id_tipo_permiso"
                    label="Seleccionar tipo de permiso"
                    outline
                  />
                </v-flex>
                <v-flex md12>
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="unidades_generales"
                    item-value="id_unidad"
                    item-text="nombre_unidad"
                    v-model="form.id_unidad_general"
                    @input="obtenerListaFuncionarios()"
                    label="Unidad general"
                    outline
                  />
                </v-flex>
                <v-flex md12>
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="unidades_especificas"
                    item-value="id_unidad"
                    item-text="nombre_unidad"
                    v-model="form.id_unidad_especifica"
                    @input="obtenerListaFuncionarios()"
                    label="Unidad especifica"
                    maxlength="50"
                    outline
                  />
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.numero"
                    label="Número"
                    @input="obtenerListaFuncionarios()"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="estados"
                    item-value="id"
                    item-text="descripcion"
                    v-model="form.id_estado"
                    @input="obtenerListaFuncionarios()"
                    label="Estado"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.hora_desde"
                    label="Hora desde"
                    type="time"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.hora_hasta"
                    label="Hora hasta"
                    type="time"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    outline
                    clearable
                  />
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.paterno"
                    label="Paterno"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.materno"
                    label="Materno"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.nombres"
                    label="Nombres"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.ci"
                    label="Cédula de identidad"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.item"
                    label="Item"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 class="py-0">
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="entregados"
                    item-value="id"
                    item-text="entregado"
                    v-model="form.entregado"
                    @input="obtenerListaFuncionarios()"
                    label="Estado entregado"
                    outline
                    clearable
                  />
                </v-flex>
              </v-layout>
              <v-btn
                :disabled="!bandera_boton_buscar"
                color="rgba(31,14,180,0.3)"
                @click="
                  obtenerListaFuncionarios(form.fecha_inicio, form.fecha_fin)
                "
                type="submit"
              >
                <v-icon>search</v-icon>
                Buscar
              </v-btn>
              <v-btn
                color="rgba(158,11,127,0.6)"
                @click="limpiarCampos()"
                type="submit"
              >
                <v-icon>redo</v-icon>
                Limpiar
              </v-btn>
              <!-- <v-btn
                :disabled="!bandera_boton_buscar"
                color="rgba(50,150,40,0.7)"
                title="Ver reporte "
                type="submit"
                @click.prevent="verReporte(form, 6)"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn> -->
            </v-container>
          </v-card-text>
        </v-form>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="lista_funcionarios"
          :no-data-text="
            loading ? 'Cargando...' : 'No se tiene registros de permisos'
          "
          :disable-initial-sort="true"
          :loading="loading"
          no-results-text="No se encontraron coincidencias"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{ props.item.numero }}
            </td>
            <td class="text-xs-center">
              {{ props.item.uni }}
            </td>
            <!-- <td class="text-xs-center">
              {{ $moment(props.item.fecha_incor).format("DD/MM/YYYY") }}
            </td> -->
            <td class="text-xs-center">
              {{ props.item.nom }} {{ props.item.pat }} {{ props.item.mat }}
            </td>
            <td class="text-xs-center">
              {{ props.item.item }}
            </td>
            <td class="text-xs-center">
              {{ props.item.nro_doc }}
            </td>
            <td class="text-xs-center">
              {{ props.item.cargo }}
            </td>

            <td class="text-xs-center">
              {{ props.item.permiso }}
            </td>
            <td class="text-xs-center">
              {{ props.item.estado }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.fecha_permiso
                  ? $moment(props.item.fecha_permiso).format("DD/MM/YYYY")
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.fecha_desde
                  ? $moment(props.item.fecha_desde).format("DD/MM/YYYY")
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.fecha_hasta
                  ? $moment(props.item.fecha_hasta).format("DD/MM/YYYY")
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.hora_desde
                  ? $moment(props.item.hora_desde, "HH:mm:ss").format("HH:mm")
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.hora_hasta
                  ? $moment(props.item.hora_hasta, "HH:mm:ss").format("HH:mm")
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              <!-- Boton para ver el seguimiento del permiso -->
              <v-btn
       
                color="#006A8E"
                @click.prevent="verSeguimientoPermiso(props.item)"
                icon
                title="Ver seguimiento"
                outline
              >
                <v-icon>visibility</v-icon>
              </v-btn>
               <!-- Boton para ver el seguimiento del permiso -->
               <!-- <v-btn
              v-if="props.item.id_tipo_permiso==24"
                color="#006A8E"
                @click.prevent="verSeguimientoPermiso(props.item,2)"
                icon
                title="Ver seguimiento --"
                outline
              >
                <v-icon>visibility</v-icon>
              </v-btn> -->
              <v-btn
                v-if="
                  (props.item.id_estado == 6 || props.item.id_estado == 21) &&
                  props.item.id_tipo_permiso != 24
                "
                color="rgb(80,38,217)"
                @click.prevent="aprobarPermiso(props.item)"
                icon
                title="Aprobar permiso"
                outline
              >
                <v-icon>done</v-icon>
              </v-btn>
              <v-btn
                v-if="props.item.ruta_archivo"
                color="#F58736"
                @click.prevent="verDocumento(props.item)"
                icon
                title="Ver documento adjunto"
                outline
              >
                <v-icon>description</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  props.item.id_tipo_permiso != 95 &&
                  props.item.id_tipo_permiso != 90 &&
                  props.item.id_tipo_permiso != 18 &&
                  props.item.id_tipo_permiso != 89 &&
                  props.item.id_tipo_permiso != 98 &&
                  props.item.id_tipo_permiso != 99 &&
                  props.item.id_tipo_permiso != 8 &&
                  props.item.id_tipo_permiso != 100 &&
                  props.item.id_tipo_permiso != 101 &&
                  (props.item.id_estado == 7 ||
                    props.item.id_estado == 6 ||
                    props.item.id_estado == 21 ||
                    props.item.id_estado == 77)
                "
                color="#F58736"
                @click.prevent="verReporte(props.item)"
                icon
                title="Ver reporte"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<!-- <div v-for="item in items" :key="item.id">
            Datos persona: {{ item.nombre }}
            <br />
            ============Programacion=================
            <div
              v-for="programacion in item.programaciones"
              :key="programacion.id"
            >
              <br />
              Fecha desde: {{ programacion.fecha_desde }}
              <br />
              Fecha hasta: {{ programacion.fecha_hasta }}
              <br />
              ======= REPROGRAMACION =====
              <div
                v-for="reprogramacion in programacion.reprogramaciones"
                :key="reprogramacion.id"
              >
                -------Fecha desde: {{ reprogramacion.fecha_desde }}
  
                -------Fecha hasta: {{ reprogramacion.fecha_hasta }}
              </div>
            </div>
            =======================00total Dias: 12
          </div> -->

<script>
//import VerReporte from "./dialogs/VerReporte";
import validate from "@/common/mixins/validate";
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import VerReporte from "../permiso/dialogs/VerReporte.vue";
import VerDocumento from "./dialogs/VerDocumento.vue";
import VerPermiso from "./dialogs/VerPermisoReporte.vue";
import AprobarRRHHSinPermisos from "../permiso/dialogs/AprobarRRHHSinPermisos.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  mixins: [validate, crud],
  data() {
    return {
      form: {},
      valid: false,
      validated: 0,
      bandera_boton_buscar: true,
      tipo_permisos: [],
      entregados: [
        { id: "S", entregado: "ENTREGADO" },
        { id: "N", entregado: "NO ENTREGADO" },
      ],
      estados: [
        { id: "(22)", descripcion: "CREADO" },
        { id: "(6)", descripcion: "SOLICITADO" },
        { id: "(7,21,75,77)", descripcion: "APROBADO" },
        { id: "(16)", descripcion: "RECHAZADO" },
      ],
      loading: false,
      headers: [
        {
          text: "Número",
          value: "numero",
          align: "center",
        },
        {
          text: "Unidad",
          value: "uni",
          align: "center",
        },
        {
          text: "Nombre",
          value: "",
          align: "center",
        },
        {
          text: "Item",
          value: "item",
          align: "center",
        },
        {
          text: "CI",
          value: "nro_doc",
          align: "center",
        },
        {
          text: "Cargo",
          value: "cargo",
          align: "center",
        },

        {
          text: "Nombre del permiso",
          value: "permiso",
          align: "center",
        },
        {
          text: "Estado",
          value: "estado",
          align: "center",
        },
        {
          text: "Fecha solicitud",
          value: "fecha_permiso",
          align: "center",
        },
        {
          text: "Fecha salida",
          value: "fecha_desde",
          align: "center",
        },
        {
          text: "Fecha fin",
          value: "fecha_hasta",
          align: "center",
        },
        {
          text: "De horas",
          value: "hora_desde",
          align: "center",
        },
        {
          text: "A horas",
          value: "hora_hasta",
          align: "center",
        },

        { text: this.$t("common.actions"), sortable: false },
      ],

      unidades_generales: [],
      unidades_especificas: [],
      lista_funcionarios: [],
    };
  },
  async created() {}, 
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.obtenerTipoPermisos();
    await this.cargarListaUnidadesGenerales();
    await this.cargarListaUnidadesEspecificas();
    var date = new Date();
    let primer_dia_mes = new Date(date.getFullYear(), date.getMonth(), 1);
    primer_dia_mes = this.$moment(primer_dia_mes).format("YYYY-MM-DD");
    let ultimo_dia_año = new Date().getFullYear() + "-12-31";
    this.form.id_unidad_general = 0;
    this.form.id_unidad_especifica = 0;
    this.form.materno = "";
    this.form.paterno = "";
    this.form.nombres = "";
    this.form.ci = "";
    this.form.item = "";
    //asignar primer y ultimo dia del año
    let año = new Date().getFullYear() + "";
    let primer_dia = año + "-01-01";
    let ultimo_dia = año + "-12-31";
    this.fecha_desde = primer_dia;
    this.fecha_hasta = ultimo_dia;

    /////
    this.form.fecha_inicio = primer_dia;
    this.form.fecha_fin = ultimo_dia;
    this.bandera_boton_buscar = true;

    await this.obtenerListaFuncionarios(primer_dia, ultimo_dia);
    this.$bus.$on("closeDialogVerPermisoRepo", () => {
      
    });
  },
  // Métodos y funciones del componente
  methods: {
    async obtenerListaFuncionarios(fecha_desde, fecha_hasta) {
      this.loading = true;
      try {
        this.bandera_boton_buscar = true;
        if (this.form.fecha_inicio && this.form.fecha_fin) {
          this.lista_funcionarios = [];
          if (this.form.materno) {
            this.form.materno = this.form.materno.toUpperCase();
          }
          if (this.form.nombres) {
            this.form.nombres = this.form.nombres.toUpperCase();
          }
          if (this.form.paterno) {
            this.form.paterno = this.form.paterno.toUpperCase();
          }
          if (!this.form.id_unidad_general) {
            this.form.id_unidad_general = 0;
          }
          if (!this.form.id_unidad_especifica) {
            this.form.id_unidad_especifica = 0;
          }
          if (!this.form.materno) {
            this.form.materno = "";
          }
          if (!this.form.paterno) {
            this.form.paterno = "";
          }
          if (!this.form.nombres) {
            this.form.nombres = "";
          }
          if (!this.form.ci) {
            this.form.ci = "";
          }
          if (!this.form.item) {
            this.form.item = "";
          }
          if (!this.form.id_tipo_permiso) {
            this.form.id_tipo_permiso = "";
          }
          if (!this.form.id_estado) {
            this.form.id_estado = "()";
          }
          if (!this.form.hora_desde) {
            this.form.hora_desde = "";
          }
          if (!this.form.hora_hasta) {
            this.form.hora_hasta = "";
          }
          if (!this.form.numero) {
            this.form.numero = "";
          }
          if (!this.form.entregado) {
            this.form.entregado = "";
          }
          let res = await this.$service.graphql({
            query: `
                     query{
        runQuery(consulta:"SELECT * FROM control.fn_buscador_gral_permisos('${
          this.form.fecha_inicio
        }','${this.form.fecha_fin}',${parseInt(this.form.id_unidad_general)},'${
              this.form.paterno
            }','${this.form.materno}','${this.form.nombres}','${
              this.form.ci
            }','${this.form.item}',${parseInt(
              this.form.id_unidad_especifica
            )},'${this.form.id_tipo_permiso}','${this.form.id_estado}','','${
              this.form.hora_desde
            }','${this.form.hora_hasta}','${this.form.numero}','${
              this.form.entregado
            }') AS (id_persona integer,id_unidad integer,id_padre integer,uni varchar,pat varchar,mat varchar,nom varchar,nro_doc varchar,item varchar,fecha_incor DATE,cargo VARCHAR,permiso varchar,id_estado varchar,estado varchar, fecha_desde date, fecha_hasta date, hora_desde varchar, hora_hasta varchar, ruta_archivo varchar,fecha_permiso date,id_permiso integer,id_tipo_permiso integer,numero integer,entregado text)"){
                      respuesta
                    }
                    }
                  `,
          });

          if (res.runQuery.respuesta.length != 0) {
            this.lista_funcionarios = res.runQuery.respuesta;
          }
        } else {
          this.bandera_boton_buscar = false;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    //metodo pra aprobar permisos:
    aprobarPermiso(item) {
      try {
        const user = this.$storage.get("user");
        this.$confirm(
          "¿Usted está seguro de aprobar el permiso ?",
          async () => {
            let respuesta = await this.$service.graphql({
              query: `
								query{
								runQuery(consulta:"select control.fn_aprueba_permiso_general(${parseInt(
                  item.id_permiso
                )},77,${item.id_persona},'${user.id}')"){
									respuesta
								}
								}
							`,
            });

            let resp =
              respuesta.runQuery.respuesta[0].fn_aprueba_permiso_general;
            let resps2 = resp.split("|");

            let correcto = resps2[0];
            if (correcto == "1") {
              this.$message.success("El permiso fué aprobado");
              await this.obtenerListaFuncionarios(
                item.fecha_desde,
                item.fecha_hasta
              );
            } else {
              this.$message.error(resps2[1]);
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    // Meto para ver el seguimiento del permiso
    verSeguimientoPermiso(item) {
        this.$bus.$emit("openDialogVerPermisoRepo", item);
     
    },
    async obtenerTipoPermisos() {
      try {
        let res = await this.$service.graphql({
          query: `
            query {
							tipoPermisos(id_estado: 19) {
                rows {
                  id
                  descripcion
                  refrigerio
                  tiempo_maximo
                  tiempo_minimo
                  aprobado
                  estado {
                    descripcion
                    abrev
                  }
                }
              }
            }
          `,
        });
        let tipo_per = [];
        // res.tipoPermisos.rows.forEach((element) => {
        //   if (element.id != 24) {
        //     tipo_per.push(element);
        //   }
        // });
        let tipo_permisos = res.tipoPermisos.rows;
        let element = {
          id: 24,
          descripcion: "Papeleta de Solicitud con Cargo a Vacación",
          id_estado: 19,
        };
        tipo_permisos.push(element);
        this.tipo_permisos = tipo_permisos;
      } catch (error) {}
    },
    limpiarCampos() {
      try {
        this.form = {};
        this.bandera_boton_buscar = false;
      } catch (error) {
        console.log(error);
      }
    },
    verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    async cargarListaUnidadesGenerales() {
      try {
        let res = await this.$service.graphql({
          query: `
                query{
                  vUnidadesGeneraless(lista_niveles:"0,1"){
                    rows{
                      id_unidad
                      nombre_unidad
                      nivel
                    }
                  }
                }
            `,
        });
        this.unidades_generales = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    },
    verReporte(item) {
      // item.id_tipo_permiso = 37;
      this.$bus.$emit("openDialogVerReportePermiso", item);
    },
    async cargarListaUnidadesEspecificas() {
      try {
        let res = await this.$service.graphql({
          query: `
                query{
                  vUnidadesGeneraless{
                    rows{
                      id_unidad
                      nombre_unidad
                      nivel
                    }
                  }
                }
            `,
        });
        this.unidades_especificas = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    },
    save() {
      try {
      } catch (error) {
        console.log(error);
      }
    },
  },
  // Definición de componentes importados
  components: {
    VerReporte,
    VerDocumento,
    VerPermiso,
    AprobarRRHHSinPermisos,
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/ReportePermisos.vue